import { Grid } from '@mui/material'
import moment from 'moment'
import PropTypes from 'prop-types'
import React from 'react'
import MultiContactsAutocomplete from 'referencial/components/contact/components/MultiContactsAutocomplete'
import MultiContributorsAutocomplete from 'referencial/components/contributor/components/MultiContributorsAutocomplete'
import i18n from 'simple-react-i18n'
import useSandreList from 'utils/customHook/useSandreList'
import { authorizeContributors, authorizeFilter } from 'utils/HabilitationUtil'
import Input from '../../../components/forms/Input'
import Select from '../../../components/forms/Select'
import SimpleDatePicker from '../../../components/forms/SimpleDatePicker'
import Textarea from '../../../components/forms/Textarea'
import { getDate } from '../../../utils/DateUtil'
import { hasValue } from '../../../utils/NumberUtil'
import { SANDRE } from 'referencial/constants/ReferencialConstants'
import { shallowEqual, useSelector } from 'react-redux'


const FormCampaign = ({
    campaign = {},
    disabled = {},
    size = '',
    onChangeCampaign = () => { },
}) => {
    const campaignStatus = useSandreList(SANDRE.CAMPAGNES_STATUT)
    const campaignTypes = useSandreList(SANDRE.CAMPAGNES_TYPE)

    const {
        beginningApplication,
        endingApplication,
        name,
        statut,
        contactCode,
        administratorCode,
        contributorCode,
        comment,
        campaignType,
        secondaryContacts,
    } = campaign

    const {
        contacts,
        contributors,
        accountUser,
    } = useSelector(store => ({
        contacts: store.ContactReducer.contacts,
        contributors: store.ContributorReducer.contributors,
        accountUser: store.AccountReducer.accountUser,
    }), shallowEqual)

    const startDate = beginningApplication && moment(beginningApplication, 'DD/MM/YYYY').valueOf()
    const endDate = endingApplication && moment(endingApplication, 'DD/MM/YYYY').valueOf()
    return (
        <div className={size}>
            <Grid container spacing={2}>
                <Grid size={6}>
                    <Input
                        title={i18n.name}
                        value={name}
                        onChange={value => onChangeCampaign({ name: value })}
                        {...disabled}
                    />
                </Grid>
                <Grid size={3}>
                    <SimpleDatePicker
                        id='beginningApplication'
                        label={i18n.startDate}
                        value={startDate}
                        onChange={v => onChangeCampaign({ beginningApplication: v && getDate(v) })}
                        max={endDate}
                        {...disabled}
                    />
                </Grid>
                <Grid size={3}>
                    <SimpleDatePicker
                        id='endingApplication'
                        label={i18n.endDate}
                        value={endDate}
                        onChange={v => onChangeCampaign({ endingApplication: v && getDate(v) })}
                        min={startDate}
                        {...disabled}
                    />
                </Grid>
                <Grid size={6}>
                    <Select
                        options={campaignTypes}
                        value={campaignType}
                        label={i18n.type}
                        keyLabel='name'
                        keyValue='code'
                        returnNull
                        onChange={e => onChangeCampaign({ campaignType: e })}
                        {...disabled}
                    />
                </Grid>
                <Grid size={6}>
                    <Select
                        integerValue
                        options={campaignStatus}
                        value={statut}
                        label={i18n.status}
                        keyLabel='label'
                        keyValue='code'
                        returnNull
                        onChange={value => onChangeCampaign({ statut: value })}
                        {...disabled}
                    />
                </Grid>
                <Grid size={4}>
                    <MultiContactsAutocomplete
                        options={authorizeFilter(contacts, accountUser, contactCode, 'contributor')}
                        label={i18n.referent}
                        onChange={ id => onChangeCampaign({ contactCode: id })}
                        values={contactCode}
                        {...disabled}
                    />
                </Grid>
                <Grid size={4}>
                    <MultiContributorsAutocomplete
                        options={authorizeContributors(contributors, accountUser, administratorCode)}
                        label={i18n.administrator}
                        onChange={ id => onChangeCampaign({ administratorCode: id })}
                        values={administratorCode}
                        {...disabled}
                    />
                </Grid>
                <Grid size={4}>
                    <MultiContributorsAutocomplete
                        options={authorizeContributors(contributors, accountUser, parseInt(contributorCode))}
                        label={i18n.contributors}
                        onChange={ id => onChangeCampaign({ contributorCode: hasValue(id) && `${id}` || undefined })}
                        values={parseInt(contributorCode)}
                        {...disabled}
                    />
                </Grid>
                <Grid size={12}>
                    <MultiContactsAutocomplete
                        multiple
                        options={contacts}
                        label={i18n.secondaryContacts}
                        limit={5}
                        onChange={ids => onChangeCampaign({ secondaryContacts: ids || [] })}
                        values={secondaryContacts}
                        {...disabled}
                    />
                </Grid>
                <Grid size={12}>
                    <Textarea
                        title={i18n.comment}
                        value={comment}
                        onChange={value => onChangeCampaign({ comment: value })}
                        {...disabled}
                    />
                </Grid>
            </Grid>
        </div>
    )
}

FormCampaign.propTypes = {
    campaign: PropTypes.shape({
        beginningApplication: PropTypes.string,
        endingApplication: PropTypes.string,
        name: PropTypes.string,
        campaignType: PropTypes.number,
        statut: PropTypes.number,
        contactCode: PropTypes.number,
        administratorCode: PropTypes.number,
        contributorCode: PropTypes.number,
        comment: PropTypes.string,
    }),
    disabled: PropTypes.shape({
        active: PropTypes.bool,
        disabled: PropTypes.bool,
    }),
    onChangeCampaign: PropTypes.func,
    size: PropTypes.string,
}

export default FormCampaign